import {
  Radio as ChakraRadio,
  RadioGroup as ChakraRadioGroup,
  type RadioProps as ChakraRadioProps,
  type RadioGroupProps as ChakraRadioGroupProps,
} from "@chakra-ui/react";

export function Radio(props: ChakraRadioGroupProps) {
  return <ChakraRadioGroup {...props} />;
}

export function RadioItem(props: ChakraRadioProps) {
  return <ChakraRadio colorScheme="pink" {...props} />;
}

Radio.Item = RadioItem;
